var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkI(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6875 7C12.6875 10.1411 10.1411 12.6875 7 12.6875C3.85888 12.6875 1.3125 10.1411 1.3125 7C1.3125 3.85888 3.85888 1.3125 7 1.3125C10.1411 1.3125 12.6875 3.85888 12.6875 7ZM14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM6.99964 5.6481C7.32207 5.6481 7.58298 5.90901 7.58298 6.23144V10.3182C7.58298 10.6406 7.32207 10.9015 6.99964 10.9015C6.67722 10.9015 6.41631 10.6406 6.41631 10.3182V6.23144C6.41631 5.90901 6.67722 5.6481 6.99964 5.6481ZM7.00004 3.58773C6.61344 3.58773 6.30004 3.90113 6.30004 4.28773C6.30004 4.67433 6.61344 4.98773 7.00004 4.98773C7.38664 4.98773 7.70004 4.67433 7.70004 4.28773C7.70004 3.90113 7.38664 3.58773 7.00004 3.58773Z",
    fill: "#5E717E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkI);
export default __webpack_public_path__ + "static/media/dark_i.6c34b25c6845cd347c34bd2ae6050d28.svg";
export { ForwardRef as ReactComponent };